import IMeetingService from "../../spi/IMeetingService";
import IMeeting, { IMeetingStatus, IMeetingPresenter, IMeetingUserStatus, IMeetingParticipant, IMeetingPresentation, ISlideType, convertToMeeting } from "../../../types/IMeeting";
import FirebaseService from "./FirebaseService";

export default class FirebaseMeetingService implements IMeetingService {

    async getMeetings(forUserId:string, startTime: number, endTime: number): Promise<Array<IMeeting>> {
        let meetings:Array<IMeeting> = [];
        try {
            const snapshot = await FirebaseService.getInstance()
                                .meetings(forUserId)
                                .once("value");
                                //.orderByChild('createdAt')
                                //.startAfter(rowsPerPage * pageNumber)
                                //.limitToLast(rowsPerPage);
            snapshot.forEach((child:any) => {
                const key = child.key;
                const m = child.val();
                const meeting:IMeeting = convertToMeeting(m);
                meeting.uid = key;
                meetings.push(meeting);
            });
        }catch(e){
            throw e;
        }
        return meetings;
    }
    
    async getMeeting(forUserId:string, meetingId: string): Promise<IMeeting> {
        let meeting:IMeeting = {} as IMeeting;
        try{
            const snapshot = await FirebaseService.getInstance()
                                .meeting(forUserId, meetingId)
                                .once("value");
            const m:any = snapshot.val();
            const key:string = snapshot.key;
            //meeting = this._buildIMeetingObject(key, m);
            meeting = convertToMeeting(m);
            meeting.uid = key;
        }catch(e){
            throw e;
        }
        return meeting;
    }
/*
    _buildIMeetingObject = (key: string, m: any):IMeeting => {
        const presenter:IMeetingPresenter = {
            displayName : m.presenter.displayName,
            id : m.presenter.id,
            imageUrl : m.presenter.imageUrl,
            status : this._decodeMeetingUserStatus(m.presenter.status),
            audio : {
                audioUid : m.presenter.audio.audioUid,
                channelName : m.presenter.audio.channelName,
                isMute : m.presenter.audio.isMute,
                optedIn : m.presenter.audio.optedIn
            }
        }

        const participants:Array<IMeetingParticipant> = m.participants == null ? [] : 
            m.participants.map((p:any) => {
                return {
                    displayName : p.displayName,
                    id : p.id,
                    imageUrl : p.imageUrl,
                    status : this._decodeMeetingUserStatus(p.status),
                    audio : {
                        audioUid : p.audio.audioUid,
                        channelName : p.audio.channelName,
                        isMute : p.audio.isMute,
                        optedIn: p.audio.optedIn
                    }
                }
            });
        const presentation:IMeetingPresentation = {
            currentSlide : m.presentation.currentSlide,
            docId : m.presentation.docId,
            docUrl : m.presentation.docUrl,
            fileName : m.presentation.fileName,
            name : m.presentation.name,
            lastSlideChangeTs : m.presentation.lastSlideChangeTs,
            noOfSlides : m.presentation.noOfSlides,
            slides : m.presentation.slides == null ? [] : 
                m.presentation.slides.map((s:any)=> {
                 return {
                    content: s.content,
                    type: this._decodeSlideType(s.type)
                 }
            })
        }
        
        return {
            uid: key,
            startTime: m.startTime,
            endTime : m.endTime,
            status : this._decodeStatus(m.status),
            title : m.title,
            useAudio : m.useAudio,
            actualEndTime : m.actualEndTime,
            actualStartTime : m.actualStartTime,
            channelName : m.channelName,
            shareUrl: m.shareUrl ? m.shareUrl: '',
            presenter,
            participants,
            presentation
        };
    }

    _decodeStatus(status: string):IMeetingStatus {
        let type: IMeetingStatus = {} as IMeetingStatus;
        if(status == null)
            type = IMeetingStatus.None
        else if(status == 'SCHEDULED')
            type = IMeetingStatus.Scheduled
        else if(status == 'STARTED')
            type = IMeetingStatus.Started
        else if(status == 'END')
            type = IMeetingStatus.End

        return type;
    }

    _decodeMeetingUserStatus(status: string):IMeetingUserStatus {
        let type: IMeetingUserStatus = {} as IMeetingUserStatus;
        if(status == null || status === "OFFLINE")
            type = IMeetingUserStatus.Offline
        else if(status == 'ONLINE')
            type = IMeetingUserStatus.Online

        return type;
    }

    _decodeSlideType(status: string):ISlideType {
        let type: ISlideType = {} as ISlideType;
        if(status == null || status === "LINK")
            type = ISlideType.link
        else if(status == 'HTML')
            type = ISlideType.html

        return type;
    }
*/
    async createMeeting(forUserId: string, m: IMeeting): Promise<IMeeting> {
        let meeting:IMeeting = {} as IMeeting;
        try{
            delete m.uid;
            let key = FirebaseService.getInstance().meetings(forUserId).push(m).key;
            meeting = m;
            meeting.uid = key;
        }catch(e){
            debugger
            throw e;
        }
        return meeting;
    }
    
    async updateMeeting(forUserId:string, m: IMeeting): Promise<IMeeting> {
        let meeting:IMeeting = {} as IMeeting;
        try{
            if(m.uid != null){
                await FirebaseService.getInstance().meeting(forUserId, m.uid).set(m);
            }
        }catch(e){
            throw e;
        }
        return meeting;
    }
    
    async deleteMeeting(forUserId: string, uid: string): Promise<boolean> {
        try{
            if(uid != null)
                await FirebaseService.getInstance().meetings(forUserId).doc(uid).delete()
        }catch(e){
            throw e;
        }
        return true;
    }

    async createSharecode(shareObject: any): Promise<any> {
        let shareCode = "";
        try {
            shareCode = await FirebaseService.getInstance().database().ref().child('sharecodes').push().key;
            FirebaseService.getInstance().sharecode(shareCode).set(shareObject);
        }catch(e){
            throw e;
        }
        return shareCode;
    }

    async getSharedDocument(sharecode: any): Promise<any> {
        let sharecodeObj = {};
        try {
            const snapshot =  await FirebaseService.getInstance()
                                .sharecode(sharecode)
                                .once("value");
            const obj:any =  snapshot.val();
            sharecodeObj = await this.getMeeting(obj.userId, obj.meetingId);
        }catch(e){
            throw e;
        }
        return sharecodeObj;
    }

    async shareMeeting(obj: any): Promise<any> {
        let response:any = "";
        try {
            response = await FirebaseService.getInstance().share(obj);
        }
        catch(e) {
            throw e;
        }
        return response
    }

}